import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import DictionariesTableColumns from './DictionariesTableColumns';

const DictionariesTableHeader = ({
  readStatus,
  readErrors,
  category,
  columns,
  hideColumns,
  children,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
    >
      {children}
    </TableHeader>
    {!hideColumns && <DictionariesTableColumns category={category} columns={columns} />}
  </Table.Header>
);

export default DictionariesTableHeader;
